import API from '../API/ApiURL';
import { axiosNode } from '../config/axiosConfig';
import { alertErrorResponse } from '../utils/alertResponseHttpUtil';

const ROUTE = `${API.serverUrl}empleados`;

export default {
  async crear(data) {
    try {
      const response = await axiosNode.post(ROUTE, data);
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async buscarTodos(filtros) {
    try {
      const params = getParamsBuscarTodos(filtros);
      const response = await axiosNode.get(ROUTE, { params });
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async actualizar(id, data) {
    try {
      const response = await axiosNode.put(`${ROUTE}/id/${id}`, data);
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async sincronizarEmpleados(data) {
    try {
      const response = await axiosNode.put(`${ROUTE}/sincronizacion`, data);
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async borrar(id) {
    try {
      const response = await axiosNode.delete(`${ROUTE}/id/${id}`);
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async buscarPorDocumento(NumeroDocumento) {
    try {
      return await axiosNode.get(`${ROUTE}/numeroDocumento/${NumeroDocumento}`);
    } catch (error) {
      return error.response.data;
    }
  },

  async buscarPorEmpresa(nit) {
    try {
      const response = await axiosNode.get(`${ROUTE}/empresa/${nit}`);
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async verificarPorSucursal(nit, IdSucursal) {
    try {
      const response = await axiosNode.get(
        `${ROUTE}/nit/${nit}/sucursal/${IdSucursal}/verificar-sucursal`
      );
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },
};

const getParamsBuscarTodos = (filtros = null) => {
  if (!filtros) {
    return {};
  }

  const {
    numeroDocumento,
    tipoContrato,
    nit,
    idSucursal,
    bloqueado,
    disponible,
    embargo,
    estaRetirado,
    page,
    limit,
  } = filtros;
  const params = {};

  if (numeroDocumento) {
    params.numeroDocumento = numeroDocumento;
  }
  if (tipoContrato) {
    params.tipoContrato = tipoContrato;
  }
  if (nit) {
    params.nit = nit;
  }
  if (idSucursal) {
    params.idSucursal = idSucursal;
  }
  if (bloqueado) {
    params.bloqueado = bloqueado;
  }
  if (disponible) {
    params.disponible = disponible;
  }
  if (embargo) {
    params.embargo = embargo;
  }
  if (estaRetirado !== undefined) {
    params.estaRetirado = estaRetirado;
  }
  if (page) {
    params.page = page;
  }
  if (limit) {
    params.limit = limit;
  }
  return params;
};
